<script setup lang="ts">
/********************
 * COMPOSITIONS      *
 ********************/
const localePath = useLocalePath();
</script>

<template>
  <header class="ci-header-account mb-6 border-b border-gray-20 bg-white">
    <div class="container flex justify-center py-2">
      <nuxt-link :to="localePath({ name: 'index' })">
        <img
          alt="logo"
          class="max-w-[200px] px-0 py-2"
          height="39"
          loading="lazy"
          src="~/assets/svg/logo_coloured_horizontal.svg"
          width="200"
        />
      </nuxt-link>
    </div>
  </header>
</template>
